import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57260362"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-thumbs-up fs-5" })
], -1))
const _hoisted_4 = { class: "mx-2" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-hand-paper fs-5" })
], -1))
const _hoisted_7 = { class: "mx-2" }
const _hoisted_8 = {
  key: 1,
  class: "number rounded-circle fs-8 d-flex cursor-pointer bg-white fw-bold items-align-center justify-content-center"
}

import { translate } from '@/languages/i18n'
import { computed, PropType } from 'vue'
import { numberWithCommas } from '@/constants/common.ts'

type Type = 'like' | 'interest'

export default /*#__PURE__*/_defineComponent({
  props: {
  type: {
    type: String as PropType<Type>,
    default: 'like',
  },
  like: Boolean,
  interest: Boolean,
  handleLikeOrInterest: {
    type: Function as PropType<() => void>,
  },
  count: {
    type: Number,
    default: 0,
  },
  id: Number,
  loadingLike: Boolean,
},
  setup(__props) {

const props = __props



const textObj = {
  like: translate('like'),
  interest: translate('interest'),
}

const activeBtn: boolean = computed(() => props[props.type])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (__props.type === 'like')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.handleLikeOrInterest && __props.handleLikeOrInterest(...args))),
            class: _normalizeClass([_unref(activeBtn) ? 'active' : '', 'border-0 me-3 rounded-pill fw-bold d-flex align-items-center', __props.loadingLike ? 'btn_opacity' : '', __props.like ? 'btn__active' : '']),
            disabled: __props.loadingLike
          }, [
            _hoisted_3,
            _createElementVNode("span", _hoisted_4, _toDisplayString(textObj[__props.type]), 1)
          ], 10, _hoisted_2))
        : (__props.type === 'interest')
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (__props.handleLikeOrInterest && __props.handleLikeOrInterest(...args))),
              class: _normalizeClass([_unref(activeBtn) ? 'active' : '', 'border-0 me-3 rounded-pill fw-bold d-flex align-items-center ', __props.interest ? 'btn__active' : '']),
              disabled: __props.loadingLike
            }, [
              _hoisted_6,
              _createElementVNode("span", _hoisted_7, _toDisplayString(textObj[__props.type]), 1)
            ], 10, _hoisted_5))
          : _createCommentVNode("", true)
    ]),
    (__props.count > 0)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass([' fs-8 ms-lg-0 ms-3 d-flex cursor-pointer bg-white fw-bold items-align-center justify-content-center fw-bold', __props.interest || __props.like ? 'number' : ''])
        }, _toDisplayString(_unref(numberWithCommas)(__props.count)), 3))
      : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(numberWithCommas)(__props.count)), 1))
  ]))
}
}

})